import { CommonDataDTO } from '@app/requests/model/combos-model';
export interface UserDataCreate {
  selectedUser: string;
  commercial: string;
  hostCode: string;
  division: string;
  dischargeDate: string;
  nifNie: string;
  email: string;
  externalCommercial: string;
  address: string;
  town: string;
  province: string;
  postalCode: string;
  contactPhone: string;
}

export interface TestTable {
  user: string;
  username: string;
  type: string;
  codehost: string;
  profile: string;
  act: string;
  revolving: string;
  atributions: string;
}

export interface SearchQuery {
  userDesc?: string;
  username?: string;
  filterUserId?: string;
  pageIndex?: number;
  pageSize?: number;
}

export interface SearchResponse {
  totalItems: number;
  numPages: number;
  pageSize: number;
  pageIndex: number;
  users: DetailedUser[];
}

export interface TreeUser {
  selectedUserId: string;
  selectedUserType: string;
  selectedDivision: number;
  filterUserId: string;
  filterUsername: string;
  filterUserDesc: string;
  pageIndex: number;
  pageSize: number;
}

export interface TreeUserResponse {
  usersAbove: TreeUserAbove[];
  usersBelow: {
    totalItems: number;
    numPages: number;
    pageSize: number;
    pageIndex: number;
    users: DetailedUser[];
  };
}

export interface TreeUserAbove {
  userId: string;
  userType: string;
  username: string;
  userDesc: string;
  division: number;
}

export interface DetailedUser {
  userId: string;
  userType: string;
  parentId: string;
  parentType: string;
  division: number;
  userClass: string;
  intTrader: string;
  extTrader: string;
  username: string;
  userDesc: string;
  supersededId: string;
  supersededDesc: string;
  supersededParentId: string;
  brand: string;
  sessionId: string;
  acceptance: true;
  changePassword: true;
  nif: string;
  name: string;
  phone: string;
  email: string;
  activated: string;
  zipCode: string;
  address: string;
  firstSurname: string;
  lastSurname: string;
  businessName: string;
  op: string;
  franchise: string;
  attribIds: string[];
  urls: string[];
}

export interface AtribucionRegisterUserDto {
  atributionNumber: string; //puede que sea number
  atributionName: string;
  activada: string;
  index: number;
}

export interface CommercialData {
  user: string;
  userName: string;
  type: string;
  division: string;
  hostCode: string;
  activated: string;
  atributions: string[];
}

export interface OperationDto {
  operationNumber: string;
  status: string;
  startDate: string;
  endDate: string;
  clientName: string;
  vendor: string;
  product: string;
  financed: string;
  protected: string;
  //TODO: AQUI VAN LOS ATRIBUTOS DE MOSTRAR LOS ICONOS QUE APARECEN
  print: string;
  sign: string;
  comments: string;
  consultDocuments: string;
  details: string;
  seeTrace: string;
}

export interface OperationTraceDto {
  date: string;
  description: string;
  user: string;
}

export interface SearchOperationDto {
  operation: string;
  nif_nie: string;
}

export interface OperationDetail {
  numOperation: string;
  numCon: string;
  dateEntry: string;
  dateStatus: string;
  nameHolder: string;
  nameVendor: string;
  prod: string;
  financed: string;
  finacialProduct: string;
  prot: string;
  printCode: string;
  ine: false;
  print: false;
  digitalSignature: string;
  digitalSignatureFlag: string;
  sendAsync: false;
  captacionCanal: string;
  operative: string;
  comarca: string;
  language: string;
}
export interface WhitelistDTO {
  entityId: string;
  userId: string;
}

export interface UserDTO {
  userId: string;
  userType: string;
  parentId: string;
  parentType: string;
  division: number;
  userClass: string;
  intTrader: string;
  extTrader: string;
  username: string;
  userDesc: string;
  supersededId: string;
  supersededDesc: string;
  supersededParentId: string;
  sessionId: string;
  acceptance: boolean;
  changePassword: boolean;
  nif: string;
  name: string;
  firstSurname: string;
  lastSurname: string;
  businessName: string;
  op: string;
  franchise: string;
  urls: string[];
}

export interface BrandMaintenanceDTO {
  attachDocumentsDTO: AttachDocumentDTO;
  brand: string;
  language: string;
  highBeneficiary: string;
  numMaxBeneficiary: string;
  highPurchase: string;
  highNoPurchase: string;
  highEmplCode: string;
  highRefCode: string;
  highInsurance: string;
  postalCodeNor: string;
  discountPercentage: string;
  corporateColor: string;
}

export interface AttachDocumentDTO {
  fileName: string;
  description: string;
  base64: string;
  extension: string;
}

export interface RequestPasswordDTO {
  user: string;
}

export interface RequestOwnPasswordDTO {
  user: string;
  password: string;
  noExpires: boolean;
}

export interface ResponsePasswordDTO {
  passwordGenerated: string;
}

export interface RequestEcommerceReportDTO {
  operationNumber: string;
  nifNie: string;
  idEcommerce: string;
  name: string;
  lastName1: string;
  lastName2: string;
  guid: string;
  initDate: string;
  endDate: string;
  updDate: string;
}

export interface RequestEcommerceDetailReportDTO {
  idEcommerce: string;
  operationNumber: string;
  guid: string;
  numContract: number;
  orderReference: number;
  channel: string;
}

export interface RequestEcommerceDetailTPVReportDTO {
  idEcommerce: string;
  guid: string;
  orderCode: string;
  fuc: number;
  codeAuthorization: string;
}

export interface EcommerceReportDTO {
  idEcommerce: string;
  guid: string;
  codAutorization: string;
  numOperacion: string;
  numContract: number;
  orderReference: number;
  guidCheckLgty: string;
  guidContract: string;
  stateProcess: string;
  name: string;
  lastname1: string;
  lastname2: string;
  channel: string;
}

export interface EcommerceReportDetailDTO {
  idEcommerce: string;
  guid: string;
  codAutorization: string;
  numOperacion: string;
  numContract: number;
  orderReference: number;
  guidCheckLgty: string;
  guidContract: string;
  codStateScoring: string;
  msgStateScoring: string;
  dateScoring: string;
  codStateTpv: string;
  msgTpv: string;
  dateTpv: string;
  stateProcess: string;
  dateProcess: string;
  codFinalEcommerce: string;
  descFinalEcommerce: string;
  nifNie: string;
  typeDoc: string;
  name: string;
  lastname1: string;
  lastname2: string;
  nameAddress: string;
  numAddress: string;
  stair: string;
  floor: string;
  door: string;
  postalCode: string;
  population: string;
  mobilePhone: string;
  phone: string;
  email: string;
  language: string;
  channel: string;
  consentsDTO: ConsentsDTO;
}

export interface DetailEcommerceTPVReportDTO {
  id: string;
  guid: string;
  orderCode: string;
  amount: number;
  money: number;
  productDescription: string;
  holder: string;
  fuc: number;
  business: string;
  language: number;
  terminalNumber: number;
  transactionType: string;
  codeAuthorization: string;
  transactionDate: string;
  transactionHour: string;
  responseCode: string;
  securePayment: string;
  cardType: string;
  updateDate: string;
}

export interface PasswordPoliciesDTO {
  pinQuantityNoRepeat: number;
  quantityTimeFailedAttempts: number;
  numAttemptsAuthLock: number;
  quantityTimeAuthAttempts: number;
  quantityLockoutTime: number;
  numFailedAttemps: number;
  numForgotAuthAtemps: number;
  quantityExpirationDays: number;
  numExpirationDays: number;
  numUserAuthAttemps: number;
  quantityTimeAttempsUser: number;
}

export interface ResponseCombosAdministratorReportDTO {
  divisions: CommonDataDTO[];
  profiles: CommonDataDTO[];
  attributions: CommonDataDTO[];
  internalCommercialUsers: CommonDataDTO[];
  externalCommercialUsers: CommonDataDTO[];
  offices: CommonDataDTO[];
}

export interface RequestAdministratorReportDTO {
  userHost: string;
  divisionId: string;
  typeBS: string;
  userClassNum: string;
  attribution: string;
  registerDateFrom: string;
  registerDateTo: string;
  dropDateFrom: string;
  dropDateTo: string;
  internalCommercialUserId: string;
  externalCommercialUserId: string;
  office: string;
  activated: string;
  order1: string;
  order2: string;
  order3: string;
}

export interface ResponseAdministratorReportDTO {
  userId: string;
  userType: string;
  parentId: string;
  parentType: string;
  username: string;
  nif: string;
  activated: string;
  userClass: string;
  email: string;
  registerDate: string;
  dropDate: string;
  division: number;
  firstSurname: string;
  lastSurname: string;
  name: string;
  userDesc: string;
  internalTrader: string;
  externalTrader: string;
  userTypeBS: string;
  office: string;
}

export interface CombosReportResponseDTO {
  requestStatus: ChargeComboResponseDTO[];
  fileStatus: ChargeComboResponseDTO[];
  cancelReasonOptions: ChargeComboResponseDTO[];
  contractVersion: string[];
}

export interface ChargeComboResponseDTO {
  key: string;
  description: string;
}

export interface RequestDigitalSignatureReportDTO {
  operationNumber: string;
  // version: string;
  nifNie: string;
  // mobilPhone: string;
  // name: string;
  // lastName1: string;
  // lastName2: string;
  // email: string;
  guid: string;
  // requestStatus: string;
  // fileStatus: string;
  // cancelOption: string;
  // cancelReason: string;
  // initDate: string;
  // endDate: string;
  // updateDate: string;
}

export interface RequestCancelSignatureDTO {
  guid: string;
  externalId: string;
}

export interface DigitalSignatureResponseDTO {
  digitalSignReportVO: DigitalSignReportVO[];
  cancelMessage: string;
}

export interface DigitalSignReportVO {
  dataWeb: PeticionVO;
  dataHost: SignatureVO;
  dataLogalty: SignatureVO;
  printCertificate: string;
  updateStates: string;
  messageWeb: string;
  messageHost: string;
  cancelOperation: string;
  consentsDTO: ConsentsDTO;
  cancelMessage: string;
}

export interface RequestCertificateDTO {
  guid: string;
}

export interface CertificateResponseDTO {
  file: any[];
}

export interface RequestUpdateStatesDTO {
  guid: string;
}

export interface PeticionVO {
  service: string;
  time2close: string;
  time2save: string;
  time2start: string;
  retryprotocol: string;
  synchronous: string;
  signMethods: string;
  lopd: string;
  userdatatransfer: string;
  signlevel: string;
  tsa: string;
  duplicateKeyOff: string;
  updateDate: string;
  generator: string;
  creation_date: string;
  language: string;
  url: string;
  url_back: string;
  request_meta_email: string;
  email_from: string;
  enforced_download: string;
  firstname: string;
  lastname1: string;
  lastname2: string;
  uuid: string;
  phone: string;
  mobile: string;
  email: string;
  fax: string;
  legalIdentity_type: string;
  legalIdentity_jurisdictionCountry: string;
  legalIdentity_issuer: string;
  legalIdentity_id: string;
  file_pdf_base64: string;
  result: string;
  guid: string;
  filename: string;
  externalId: string;
  versionContract: string;
  document_result: string;
  document_result_date: string;
  document_result_comment: string;
  final_state: string;
  final_state_date: string;
  final_state_comment: string;
  cancel_reason: string;
  cancel_reason_option: string;
  strNumSol: string;
  strNumContrato: string;
  strEstPeticion: string;
  process: string;
  fileState: string;
  lstIntervinientes: any[];
  user: string;
  intNumIntervinientes: number;
  insuranceInter: string;
  strIdioma: string;
  idSession: string;
  typeSignature: string;
  type: string;
  dispositivoDTO: DeviceDTO;
  companyVO: CompanyVO;
  paramsSignature: DigitalSignatureParamDTO;
  reciver_id: string;
  groups: any;
  versionSignature: number;
  typeReal: string;
  rol: string;
  businessCIF: string;
  businessDescription: string;
  idCommerce: string;
  subjectMail: string;
  idEstablishment: string;
  financialProduct: string;
  urlCallBack: string;
  linkAdjDoc: string;
  urlAccess: string;
  endUserId: string;
  envP: string;
  typeInter: string;
  accessByDevice: string;
  typeSignatureByImport: string;
  multifirma: string;
  ine: string;
  ecommerce: boolean;
  certificate: boolean;
}

export interface DeviceDTO {
  strModelNumber: string;
  strBrand: string;
  strModel: string;
  strDisplay: string;
  strSo: string;
  strSoVersion: string;
  strIdSession: string;
  strTipoFirma: string;
}

export interface CompanyVO {
  strCifEmpresa: string;
  strDesEmpresa: string;
  legalIdentity_id: string;
  legalIdentity_type: string;
  legalIdentity_jurisdictionCountry: string;
  legalIdentity_issuer: string;
  phone: string;
  mobile: string;
  email: string;
  fax: string;
}

export interface DigitalSignatureParamDTO {
  strCdJerarquia: string;
  strImpMaxArti11: string;
  strImpMaxOpe11: string;
  strIndReenvio: string;
  strIndSeguro: string;
  strProFin: string;
  strTipFirma: string;
  strTipoJerarquia: string;
  strTitExtranjero: string;
  strTitFisico: string;
  strTitJuridico: string;
  strPaginaBackAsincrona: string;
  lnrecordatorios: number;
  ldiasCaducidad: number;
  lninter: number;
}

export interface SignatureVO {
  time2start: string;
  legalIdentity_id: string;
  result: string;
  guid: string;
  versionContrato: string;
  document_result: string;
  document_result_date: string;
  final_state: string;
  final_state_date: string;
  strNumSol: string;
  strNumContrato: string;
  strEstPeticion: string;
  strCifEmpresa: string;
  estadoFichero: string;
}

export interface ConsentsDTO {
  check_TDPFC: string;
  check_TDPFCFRSC: string;
  check_CDPFC: string;
  check_CBPDDEBP: string;
  check_TDTGSS: string;
}

export interface RequestDivisionDTO {
  division: string;
}

export interface RequestDetailUsersDTO {
  user: string;
  userType: string;
  userClass: string;
  username: string;
}

export interface ResponseDetailUsersDTO {
  userId: string;
  userType: string;
  userClass: string;
  username: string;
  userDesc: string;
  city: string;
  name: string;
  nif: string;
  firstSurname: string;
  lastSurname: string;
  phone: string;
  email: string;
  address: string;
  zipCode: string;
  businessName: string;
  registerDate: string;
  division: number;
  typeBS: string;
  brand: string;
}

export interface RequestUsersByFilterDTO {
  typeOut: string;
  division: string;
  filter: string;
  typerCreate: string;
  idExtenalCommercial: string;
  action: string;
}

export interface RequestActionDTO {
  action: string;
}

export interface RequestBrandDTO {
  user: string;
  userType: string;
  userTypeOut: string;
}

export interface ResponseBrandDTO {
  id: string;
  value: string;
}

export enum ActionEnum {
  CO = 'CO',
  WB = 'WB',
  US = 'US',
}

export interface RequestAttributionsByProfileDTO {
  profileId: string;
}

export interface ResponseAttributionsByProfileDTO {
  id: string;
  name: string;
  status: string;
}

export interface UserDependenciesRequestDTO {
  selectedUserId: string;
  selectedUserType: string;
  selectedDivision: number;
  filterUserId: string;
  filterUsername: string;
  filterUserDesc: string;
  pageIndex: number;
  pageSize: number;
}

export interface ParentUserResponseDTO {
  userId: string;
  userType: string;
  username: string;
  userDesc: string;
  division: number;
}

export interface RequestImpersonatedUserDTO {
  userId: string;
  userType: string;
  filter: string;
}

export interface ResponseImpersonatedUserDTO {
  userDescription: string;
  userId: string;
  usertype: string;
}

export interface ResponsePasswordDTO {
  passwordGenerated: string;
}

export interface RequestCreateUsersDTO {
  password: string;
  filterAttributions: string;
  profile: string;
  userDescription: string;
  userType: string;
  brand: string;
  action: ActionEnum;
  user: string;
  webUser: string;
  email: string;
  commercialUser: string;
  divisionId: string;
  filterOffices?: string;
  filterChains?: string;
}

export interface RequestVendorByFilterDTO {
  user: string;
  type: string;
  typeOut: string;
  activate: string;
}

export interface UserDetailRequestDTO {
  userId?: string;
  userName?: string;
  userType: string;
}

export interface UserDetailResponseDTO {
  userId: string;
  userType: string;
  username: string;
  userDesc: string;
  brand: string;
  supersededId: string;
  supersededDesc: string;
  profileId: string;
  profileName: string;
  chainCode: string;
  chainDesc: string;
  prescriberCode: string;
  prescriberDesc: string;
  establishmentCode: string;
  establishmentDesc: string;
  externalCommercialNif: string;
  externalCommercialDesc: string;
  internalCommercialNif: string;
  internalCommercialDesc: string;
  division: string;
  address: string;
  city: string;
  province: string;
  zipCode: string;
  email: string;
  phone: string;
  legalId: string;
  creationDate: string;
  attributions: CommonDataDTO[];
  userWeb: boolean;
}

export interface RequestDeleteUsersDTO {
  userId: string;
  password: string;
  userWeb: string;
  userType: string;
}

export interface RequestModifyUsersDTO {
  webUserOld: string;
  webUser: string;
  filterAttributions: string;
  password: string;
  email: string;
  profile: string;
  typeBS: string;
  brand: string;
  userType: string;
  divisionId?: string;
  filterOffices?: string;
  filterChains?: string;
}

export interface RequestComboReports {
  listChains?: string[];
  listPrescribers?: string[];
  officeId?: string;
}
